package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class ShiftSwapRepository(private val httpClient: HttpClient) {
    suspend fun getSwaps(workplaceId: Long): Result<List<ShiftSwapDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/shift-swaps").body()
    }

    suspend fun createSwap(req: CreateSwapRequest): Result<Unit> = runCatching {
        httpClient.post("shift-swap") { setBody(req) }
    }

    suspend fun acceptSwap(swapId: Long): Result<Unit> = runCatching {
        httpClient.put("shift-swap/$swapId/accept")
    }

    suspend fun cancelSwap(swapId: Long): Result<Unit> = runCatching {
        httpClient.put("shift-swap/$swapId/cancel")
    }
}
